import apiWorker from '../apiWorker'

const failed_name_logs = {
    create : (data) => apiWorker('post', `/v1/analytics/failed_name_logs`, data, true),
}

export default failed_name_logs;